/**
 * 机器人客服常见问题配置。
 * 直接编辑此文件即可调整欢迎语与问答内容；answer 支持换行 \n 与表情占位 [emoji_0]。
 * keywords 用于输入框文字的关键词匹配，命中任意一个即返回对应答案。
 */
/** 人工客服入口选项的固定 id */
export const HUMAN_SERVICE_ID = 'human-service';
export const BOT_NAME = '在线客服小仟';
export const BOT_WELCOME = '您好，我是机器人客服小仟！\n很高兴为您服务。\n如您在使用过程中遇到了问题，请用一句话或一个词语描述您的问题，例如：忘记密码。';
/** 选项标题 */
export const BOT_OPTIONS_LABEL = '您可能想问：';
/** 未匹配到答案时的回复 */
export const BOT_NO_MATCH = '系统未为您匹配到精准回复，是否需要联系人工客服？';
/** 转人工提示 */
export const BOT_CONNECTING = '正在为您接入人工客服，请稍候…';
/** 触发转人工的关键词 */
export const HUMAN_TRIGGER_KEYWORDS = ['人工客服', '人工', '转人工', '真人', '人工服务', '转接人工'];
export const FAQ_ITEMS = [
    {
        id: 'account-login',
        question: '账号登录问题',
        answer: '若您无法登录账号，请尝试以下操作：\n1. 确认账号、密码输入正确；\n2. 检查网络连接是否正常；\n3. 尝试退出后重新登录。\n如仍无法解决，请回复「人工客服」联系我们。',
        keywords: ['登录', '登陆', '登不上', '进不去', '无法登录', '登录不了'],
    },
    {
        id: 'reset-password',
        question: '忘记/修改密码',
        answer: '修改密码路径：我的 - 设置 - 账号与安全 - 修改密码。\n如忘记密码，可在登录页点击「忘记密码」，通过绑定手机号验证后重置。',
        keywords: ['密码', '忘记密码', '改密码', '修改密码', '重置密码'],
    },
    {
        id: 'bind-phone',
        question: '更改绑定手机号',
        answer: '更改绑定手机号路径：我的 - 设置 - 账号与安全 - 更换手机号。\n需先通过原手机号验证，再绑定新手机号。',
        keywords: ['手机号', '换绑', '绑定手机', '更换手机', '改手机号', '换手机号'],
    },
    {
        id: 'verify-code',
        question: '收不到验证码',
        answer: '收不到验证码可尝试：\n1. 确认手机号填写正确且信号正常；\n2. 检查短信是否被拦截软件屏蔽；\n3. 稍等 60 秒后重新获取。\n多次失败请回复「人工客服」处理。',
        keywords: ['验证码', '收不到', '短信', '验证短信'],
    },
    {
        id: 'realname',
        question: '实名认证',
        answer: '实名认证路径：我的 - 设置 - 实名认证。\n请准备好本人有效身份证件，按提示完成认证即可。',
        keywords: ['实名', '认证', '实名认证', '身份认证'],
    },
    {
        id: 'refund',
        question: '退款/订单问题',
        answer: '订单与退款问题，请在「我的 - 我的订单」中查看对应订单状态。\n如需退款或对订单有疑问，请回复「人工客服」并提供订单号，我们将尽快为您处理。',
        keywords: ['退款', '订单', '退钱', '付款', '支付', '充值'],
    },
    {
        id: 'complaint',
        question: '投诉举报',
        answer: '如需投诉或举报，请回复「人工客服」，并提供相关截图、时间、对象等信息，我们会认真核实并处理。',
        keywords: ['投诉', '举报', '诈骗', '骗子'],
    },
    {
        id: 'network',
        question: '网络异常',
        answer: '出现网络异常可尝试：\n1. 切换 Wi-Fi 与移动网络；\n2. 关闭后重新打开 App；\n3. 更新到最新版本。\n若问题持续，请回复「人工客服」反馈。',
        keywords: ['网络', '异常', '卡', '连不上', '闪退', '崩溃'],
    },
];
function normalize(text) {
    return text.trim().toLowerCase().replace(/\s+/g, '');
}
/** 是否为转人工请求 */
export function isHumanRequest(text) {
    const value = normalize(text);
    if (!value)
        return false;
    return HUMAN_TRIGGER_KEYWORDS.some((kw) => value.includes(normalize(kw)));
}
/** 根据输入文字关键词匹配常见问题 */
export function matchFaqByText(text) {
    const value = normalize(text);
    if (!value)
        return null;
    for (const item of FAQ_ITEMS) {
        if (value === normalize(item.question))
            return item;
    }
    for (const item of FAQ_ITEMS) {
        if (value.includes(normalize(item.question)) || normalize(item.question).includes(value)) {
            return item;
        }
    }
    for (const item of FAQ_ITEMS) {
        if (item.keywords.some((kw) => value.includes(normalize(kw))))
            return item;
    }
    return null;
}
